import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { SiteFooter } from "@/components/SiteFooter";

export function LegalLayout({ doc, testId }) {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${doc.title} · Frank369 AI`;
    return () => {
      document.title = "Waitlist Open";
    };
  }, [doc.title]);

  return (
    <div className="page legal-page" data-testid={testId}>
      <header className="brand">
        <Link className="wordmark" to="/" aria-label="Frank369.AI home" data-testid="brand-wordmark">
          Frank369.AI
        </Link>
      </header>

      <main className="legal">
        <motion.article
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="legal-eyebrow">Legal</p>
          <h1 className="legal-title" data-testid="legal-title">{doc.title}</h1>
          <p className="legal-updated">{doc.updated}</p>

          <div className="legal-body">
            {doc.sections.map((s) => (
              <section key={s.num} className={s.sub ? "legal-sub" : undefined}>
                <h2>
                  <span className="sec-num">{s.num}</span>
                  {s.heading}
                </h2>
                {s.body.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </section>
            ))}
          </div>

          <Link to="/" className="btn legal-back" data-testid="legal-back-home">
            Back to home
          </Link>
        </motion.article>
      </main>

      <SiteFooter />
    </div>
  );
}
